import {Link} from 'react-router-dom'
import './navbar.css'

export default function Navbar(){
    return(
        <div className="nav2Body p-2 ">
            <Link to="/" className="link">All</Link>
            <Link to="new_song" className="link">New Songs</Link>
            <Link to="old_song" className="link">Old Songs</Link>
        </div>
    )
}